import React from 'react';
import { withStyles, InputAdornment, colors } from '@material-ui/core';

const black64 = 'rgba(0, 0, 0, 0.64)';

const StyledAdornment = withStyles({
  root: {
    '& .MuiTypography-root': {
      fontFamily: (props) =>
        props.isprimary === 'true'
          ? 'Fredoka One, cursive'
          : 'Varela Round, sans-serif',
      color: (props) =>
        props.isprimary === 'true' ? colors.red[300] : black64,
    },
  },
})(InputAdornment);

const MainAdornment = ({ children, position = 'end', isPrimary = true }) => {
  return (
    <StyledAdornment position={position} isprimary={isPrimary.toString()}>
      {children}
    </StyledAdornment>
  );
};

export default MainAdornment;
